import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Avatar, Card, CardContent, Grid, Hidden, Paper, Typography } from '@material-ui/core';

import { getColor } from '../Config';

const styles = theme => ({
    servicesPaper: {
        backgroundColor: getColor('bg-primary'),
        color: theme.palette.common.black,
        marginBottom: theme.spacing.unit * 4,
    },
    servicesContainer: {
        padding: `${theme.spacing.unit * 6}px`,
    },
    card: {
        backgroundColor: getColor('bg-secondary'),
        display: 'flex',
    },
    cardDetails: {
        flex: 1,
    },
    center: {
        textAlign: 'center'
    },
    avatar: {
        margin: 10,
        width: 60,
        height: 60
    },
    smallAvatar: {
        margin: 5,
    }
});

const testimonials = [
    {
        name: 'Real Person',
        text: "Lorem ipsum dolor amet fashion axe trust fund disrupt wolf everyday carry. +1 kogi migas poutine deep v snackwave quinoa actually. Ethical PBR&B tofu flexitarian mixtape beard. Fanny pack portland lomo waistcoat, stumptown jean shorts coloring book vegan. 90's keffiyeh distillery yr deep v austin meditation YOLO beard.",
        image: '/images/testimonial1.jpeg',
    },{
        name: 'Another Real Person',
        text: "Lorem ipsum dolor amet tattooed trust fund locavore 90's. Artisan slow-carb bicycle rights, ethical subway tile +1 copper mug poke typewriter you probably haven't heard of them vinyl. PBR&B air plant lo-fi, normcore lumbersexual gluten-free fam small batch pabst 3 wolf moon. Bitters put a bird on it jianbing, listicle hella semiotics PBR&B you probably haven't heard of them chia. Adaptogen photo booth godard, shoreditch taxidermy migas gentrify next level squid raw denim you probably haven't heard of them chartreuse single-origin coffee food truck XOXO. Chambray photo booth pour-over mixtape, coloring book palo santo fam portland offal master cleanse you probably haven't heard of them letterpress aesthetic 8-bit unicorn. Dreamcatcher literally snackwave, wolf unicorn man bun master cleanse pitchfork.",
        image: '/images/testimonial2.jpg',
    },{
        name: 'The Realest Person',
        text: "Lorem ipsum dolor amet banjo lomo subway tile wolf microdosing. Biodiesel street art brunch wayfarers bushwick raw denim. Bitters crucifix pug mustache stumptown umami kitsch kickstarter bespoke. Stumptown street art cray tumeric. Glossier chillwave tumblr, authentic live-edge butcher blue bottle tacos hashtag lyft. Yuccie photo booth aesthetic succulents ennui coloring book banh mi dreamcatcher meditation snackwave flannel disrupt.",
        image: '/images/testimonial3.jpg',
    },
];

function Testimonials(props) {
    const { classes } = props;
    
    return (
        <Paper className={classes.servicesPaper}>
            <Grid container spacing={40} className={classes.servicesContainer}>
                <Grid item xs={12}>
                    <Typography component="h2" variant="h3" color="inherit" gutterBottom className={classes.center}>
                        Testimonials
                    </Typography>
                </Grid>
                <Grid container item spacing={40} className={classes.cardGrid} justify="center" alignItems="center">
                    {testimonials.map(testimonial => (
                        <Grid item key={testimonial.title} sm={8} xs={12}>
                            <Card className={classes.card}>
                                <div className={classes.cardDetails}>
                                    <CardContent>
                                        <Grid container>
                                            <Grid item xs={2} sm={1}>
                                                <Hidden xsDown>
                                                    <Avatar alt={testimonial.name} src={testimonial.image} className={classes.avatar} />
                                                </Hidden>
                                                <Hidden smUp>
                                                    <Avatar alt={testimonial.name} src={testimonial.image} className={classes.smallAvatar} />
                                                </Hidden>
                                            </Grid>
                                            <Grid item xs={10} sm={11}>
                                                <Typography component="h2" variant="h5">{testimonial.name}</Typography>
                                                <Typography variant="subtitle1" paragraph>{testimonial.text}</Typography>
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </div>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Grid>
        </Paper>
    );
}

Testimonials.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Testimonials);